import { HttpClient } from '@angular/common/http';
import { Base } from './base';

export class Announcements extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'announcements');
  }

  query(params?: any) {
    return this.api.query(params);
  }
}
